export interface IEditableEventSubject {
  'name': string,
}

export const createEmptyEditableEventSubject = (): IEditableEventSubject => {
  return {
    'name': '',
  };
};


